// Autogenerated file
export const bidPointLoadUnloadStatusesEnum = {
    AtLoading: "AtLoading",
    Loaded: "Loaded",
    AtUnloading: "AtUnloading",
    Unloaded: "Unloaded",
};
export const bidPointLoadUnloadStatuses = [
    { label: "На загрузке", value: "AtLoading" },
    { label: "Загрузился", value: "Loaded" },
    { label: "На выгрузке", value: "AtUnloading" },
    { label: "Выгрузился", value: "Unloaded" },
];
